module.exports = __webpack_public_path__ + "static/item--window--f7@3x.dca6bdf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bedroom/item--window--f7@3x.png
// module id = 575
// module chunks = 6850842914447